import React from 'react';
import _ from 'lodash';
import AccountAddressComponent from './account-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import AccountAccountsInfoComponent from './account-accounts-info.component';
import AccountLoginDetailsComponent from './account-login-details';
import AccountBankDetailsComponent from './account-bank-details.component';
import AccountTaxDetailsComponent from './account-tax-details.component';
import ManagementAccountUsers from './account-user/containers/account-users';
import ManagementAccountLedgers from './account-ledgers/containers/account-ledgers';
import AccountBrandInfoComponent from './brand-mappings/account-brandInfo.component';
import AccountOrgRegistry from './account-org-registry/containers/account-org-registry';


export const AccountComponent = ({
    handleFormSubmit, back, id, onInnerBasicFormChange,
    selectedAddress, changeImage, organizationUnits, typeId,
    gstRegistrationType, operatingHours, accountSource, accountType, gstType,
    industryType, businessType, salutation, selectedAccounts, onInnerFormChange, handleInnerbasicFormChange, accounts,
    brandMappings, deleteSelectedBrands, getIsFavRecordDeletable, onFormFavItemChange, deleteselectedFavIcon, changeFavImage,
    logoFiles, onFormLogoItemChange, getIsLogoRecordDeletable, faviconSize, changeLogoImage, logoBackground, deleteselectedLogo,
    onFormItemBrandChange, getIsBrandRecordDeletable, handleOpen, handleClose, selectMappedAccountTypes
}: any) => {

    const tabItems = [
        {
            id: 1,
            title: 'User Details',
            component: <AccountLoginDetailsComponent
                id={id}
                onInnerBasicFormChange={onInnerBasicFormChange}
                onInnerFormChange={onInnerFormChange}
                salutation={salutation}
                selectedAccounts={selectedAccounts}
            />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Account Details',
            component: <AccountAccountsInfoComponent
                accountSource={accountSource}
                accountType={accountType}
                accounts={accounts}
                businessType={businessType}
                changeImage={changeImage}
                industryType={industryType}
                onInnerFormChange={onInnerFormChange}
                operatingHours={operatingHours}
                organizationUnits={organizationUnits}
                selectedAccounts={selectedAccounts}
                selectedAddress={selectedAddress}
                typeId={typeId}
                selectMappedAccountTypes={selectMappedAccountTypes}
            />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Bank Account Details',
            component: <AccountBankDetailsComponent
                onInnerFormChange={onInnerFormChange}
                selectedAccounts={selectedAccounts}
            />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 4,
            title: 'Tax Details',
            component: <AccountTaxDetailsComponent
                gstRegistrationType={gstRegistrationType}
                gstType={gstType}
                onInnerFormChange={onInnerFormChange}
                selectedAccounts={selectedAccounts}
            />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 5,
            title: 'Address',
            component: <AccountAddressComponent
                handleInnerbasicFormChange={handleInnerbasicFormChange}
                onInnerFormChange={onInnerFormChange}
                selectedAccounts={selectedAccounts}
                selectedAddress={selectedAddress}
            />,
            isVisible: true,
        },
        {
            id: 6,
            title: 'Users',
            component: <ManagementAccountUsers
            />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 7,
            title: 'Ledgers',
            component: <ManagementAccountLedgers
            />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 8,
            title: 'OrgRegistry',
            component: <AccountOrgRegistry
            />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 9,
            title: 'Brand Mappings',
            component: <AccountBrandInfoComponent
                changeImage={changeImage}
                deleteSelectedBrands={deleteSelectedBrands}
                getIsBrandRecordDeletable={getIsBrandRecordDeletable}
                handleClose={handleClose}
                handleOpen={handleOpen}
                onFormItemBrandChange={onFormItemBrandChange}
                logoFiles={logoFiles}
                changeFavImage={changeFavImage}
                deleteselectedFavIcon={deleteselectedFavIcon}
                onFormFavItemChange={onFormFavItemChange}
                getIsFavRecordDeletable={getIsFavRecordDeletable}
                onFormLogoItemChange={onFormLogoItemChange}
                getIsLogoRecordDeletable={getIsLogoRecordDeletable}
                faviconSize={faviconSize}
                changeLogoImage={changeLogoImage}
                logoBackground={logoBackground}
                deleteselectedLogo={deleteselectedLogo}
                brandMappings={brandMappings}
            />,
            isVisible: id > 0 ? true : false,
        }
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default AccountComponent;